import styled, { css } from 'styled-components';

const defaultWrapperWidth = '540px';

export const Form = styled.form`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    line-height: ${theme.v2.font.lineHeight.text};
  `};
`;

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 24px;
  margin: 24px 0px 24px;
  max-width: ${defaultWrapperWidth};

  div {
    width: 100%;
  }
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Info = styled.span`
  ${({ theme }) => css`
    display: block;
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.family.regular};
    margin: 24px 0px 24px;
    max-width: ${defaultWrapperWidth};
    color: ${theme.v2.colors.neutral.lowPure};

    li {
      margin-bottom: 8px;
    }

    > svg {
      position: relative;
      top: 5px;
    }

    strong {
      font-weight: ${theme.v2.font.weights.bold};
    }    

    a{
      font-weight: ${theme.v2.font.weights.bold};
    }
  `}
`;

export const Subtitle = styled.span`
  ${({ theme }) => css`
    display: inline-block;
    width: 100%;
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.family.regular};
    margin: 24px 0px 0 0;
    max-width: ${defaultWrapperWidth};
    color: ${theme.v2.colors.neutral.lowPure};
  `}
`;

export const ButtonWrapper = styled.div`
  button {
    max-height: 35px;
  }
`;


export const CheckboxLabel = styled.label`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  margin: 0px;

  label {
    width: 19px;
    height: 19px;
  }
`;

export const Text = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    display: inline-block;
    font-size:  ${theme.v2.font.sizes.xxs};
    gap: 6px;
    line-height: ${theme.v2.font.lineHeight.text};

    a {
      font-size:  ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const RadioSection = styled.div`
  ${({ disabled }) => css`
    max-width: ${defaultWrapperWidth};
    width: 100%;
    pointer-events: ${disabled ? 'none' : 'auto'};
    opacity: ${disabled ? 0.6 : 1};
  `}    
`;

export const RadioWrapper = styled.div`
  display: flex;
  gap: 16px;
  max-width: ${defaultWrapperWidth};
  width: 100%;
`;

export const Label = styled.label`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowLight};
    display: block;
    font-family: ${theme.v2.font.family.primary};
    font-size:  ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px 0px 8px;
  `}
`;

export const RadioLabel = styled.label`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowDark};
    cursor: pointer;
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size:  ${theme.v2.font.sizes.xxs};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px 0px 4px;

    label {
      width: 19px;
      height: 19px;
    }
  `}
`;

export const SelectWrapper = styled.div``;
